<template>
    <td-dialog :title="$t(title)" :visible.sync="dialogVisible" :width="'450px'" :before-close="cancel" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="networkServiceForm" ref="networkServiceForm" class="demo-form-inline" label-width="160px" @submit.native.prevent :rules="rules">
            <el-form-item :label="$t('pgCommon.SERVICE_TYPE')" prop="sType">
                <td-select
                    v-model="networkServiceForm.sType"
                    :options="options"
                    keys="sCode"
                    text="label"
                    requestType="POST"
                    :urlParam="optionsParams"
                    url="/setting/dictController/getDictValuesByType"
                    :clearable="false"
                    @change="changeServiceType"
                ></td-select>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.SERVICE_NAME')" prop="sName">
                <td-input v-model="networkServiceForm.sName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.SERVICE_IP')" prop="sIp">
                <td-input v-model="networkServiceForm.sIp"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.MAPPING_IP')" prop="sMappingIp">
                <td-input v-model="networkServiceForm.sMappingIp"></td-input>
            </el-form-item>
            <td-dynamic labelWidth="160px" :groupFlg="networkServiceForm.sType" v-model="sExtendInfo"></td-dynamic>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm" style="margin-top:40px">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from './api.js';
export default {
    props: {
        title: {
            type: String,
            defalut: ''
        },
        dialogVisible: {
            type: Boolean,
            defalut: function() {
                return false;
            }
        },
        networkServiceForm: {
            type: Object,
            defalut: function() {
                return { serviceType: '', sName: '', sIp: '', sMappingIp: '', sExtendInfo: {} };
            }
        },
        addOrEdit: {
            type: String,
            defalut: 'add'
        },
        sExtendInfo: {
            type: Object,
            defalut: {}
        }
    },
    data() {
        return {
            options: [],
            optionsParams: { sTag: 'networkServiceType' },
            saveLoading: false,
            rules: {
                sName: [
                    { required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_SERVICE_NAME'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') }
                ],
                sIp: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_SERVICE_IP'), trigger: 'blur' }, { pattern: this.$regex.IP_RULE, message: this.$t('error.ERROR_IP_FORMAT') }],
                sMappingIp: [
                    { required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_MAPPING_IP'), trigger: 'blur' },
                    { pattern: this.$regex.IP_RULE, message: this.$t('error.ERROR_IP_FORMAT') }
                ]
            }
        };
    },
    methods: {
        /**关闭按钮触发的方法 */
        cancel() {
            this.$emit('dialogClose');
        },
        /**保存成功后调用父页面的方法 */
        refreshData() {
            this.$emit('refreshData');
        },
        /**保存按钮触发的方法 */
        submitForm() {
            this.$refs.networkServiceForm.validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    this.networkServiceForm.sExtendInfo = this.sExtendInfo;
                    if (this.addOrEdit == 'add') {
                        api.addNetworkService(this.networkServiceForm, response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/networkSetting/updateNetworkService', response);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.cancel();
                            this.refreshData();
                        });
                    }
                    if (this.addOrEdit == 'edit') {
                        api.updateNetworkService(this.networkServiceForm, response => {
                            this.saveLoading = false;
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/networkSetting/updateNetworkService', response);
                                return;
                            }
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                            this.cancel();
                            this.refreshData();
                        });
                    }
                }
            });
        },
        /**改变服务类型时触发的方法 */
        changeServiceType(value) {
            this.sExtendInfo = {};
            this.networkServiceForm.sType = value;
        }
    }
};
</script>
